import React from 'react';
import { useTranslation } from 'react-i18next';

import { HeaderText, SectionContainer, SectionSubtitle } from '../../../components/Modals';
import { Flex } from '../../../components/ui/Flex';
import ToggleInput from '../../../components/ui/ToggleInput';

const CoreFeatureFormInputs = ({ form }) => {
  const { t } = useTranslation();
  return (
    <SectionContainer>
      <HeaderText alt>{t('Core Features')}</HeaderText>
      <SectionSubtitle>
        {t('Toggle core modules based on the services used by the building.')}
      </SectionSubtitle>
      <Flex direction="column" gap="16px">
        <ToggleInput
          form={form}
          name="enable_posts"
          label={t('Enable News')}
          description={t('Allow posting news or updates')}
        />

        <ToggleInput
          form={form}
          name="enable_offers"
          label={t('Enable Deals')}
          description={t('Enable building-specific promotions')}
        />

        <ToggleInput
          form={form}
          name="enable_booking"
          label={t('Enable Bookings')}
          description={t('Enable amenity booking feature')}
        />

        <ToggleInput
          form={form}
          name="enable_lock_screen"
          label={t('Enable Digital Key')}
          description={t('Allow digital key controls for users (unit locks, common doors)')}
        />

        <ToggleInput
          form={form}
          name="enable_service_requests"
          label={t('Enable Work Requests')}
          description={t('Allow residents to submit work requests')}
        />

        <ToggleInput
          form={form}
          name="enable_chat"
          label={t('Enable Chat')}
          description={t('Allow residents and managers to message each other')}
        />
      </Flex>
    </SectionContainer>
  );
};

export default CoreFeatureFormInputs;
